import React, { Component } from 'react';
import gql from 'graphql-tag';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { errorShape } from 'utils/shapes';

class PatronAssetsContainer extends Component {
  constructor(props) {
    super(props);

    this.unsubscribeFromNewData = () => {};
    this.unsubscribeFromTicketData = () => {};
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToNewData();
    this.unsubscribeFromTicketData = this.props.subscribeToTicketData();
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
    this.unsubscribeFromTicketData();
    this.unsubscribeFromTicketData = () => {};
  }

  render() {
    const {
      children,
      data: { patronAssets, error }
    } = this.props;

    if (!patronAssets || error) {
      return null;
    }

    return React.Children.map(children, child =>
      React.cloneElement(child, { patronAssets })
    );
  }
}

PatronAssetsContainer.propTypes = {
  data: PropTypes.shape({
    patronAssets: PropTypes.shape({
      tickets: PropTypes.number,
      wscore: PropTypes.number,
      gameBalance: PropTypes.number,
      sapphires: PropTypes.number
    }),
    loading: PropTypes.bool,
    error: errorShape
  })
};

const patronAssetsQuery = gql`
  query {
    patronAssets {
      tickets
      wscore
      gameBalance
      sapphires
    }
  }
`;

const SUBSCRIPTION_TICKETS = gql`
  subscription {
    ticketUpdates {
      tickets
    }
  }
`;

const SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES = gql`
  subscription {
    updatedCurrencyItemBalances {
      creditsBalance
      wscoreBalance
      sapphiresBalance
    }
  }
`;

const PatronAssetsContainerWithData = graphql(patronAssetsQuery, {
  options: { fetchPolicy: 'cache-and-network' },
  props: ({ ownProps, data }) => {
    return {
      data,
      subscribeToNewData: () => {
        return data.subscribeToMore({
          document: SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES,
          updateQuery: (prev, { subscriptionData }) => {
            const { wscoreBalance, sapphiresBalance, creditsBalance } =
              subscriptionData.data;

            return Object.assign({}, prev, {
              patronAssets: Object.assign({}, prev.patronAssets, {
                wscore: !isNil(wscoreBalance)
                  ? wscoreBalance
                  : prev.patronAssets.wscore,
                sapphires: !isNil(sapphiresBalance)
                  ? sapphiresBalance
                  : prev.patronAssets.sapphires,
                gameBalance: !isNil(creditsBalance)
                  ? creditsBalance
                  : prev.patronAssets.gameBalance
              })
            });
          }
        });
      },
      subscribeToTicketData: () => {
        return data.subscribeToMore({
          document: SUBSCRIPTION_TICKETS,
          updateQuery: (prev, { subscriptionData }) => {
            const tickets = subscriptionData.data.tickets;
            if (tickets !== undefined) {
              return Object.assign({}, prev, {
                patronAssets: Object.assign({}, prev.patronAssets, {
                  tickets: tickets
                })
              });
            }
            return null;
          }
        });
      }
    };
  }
})(PatronAssetsContainer);

export default PatronAssetsContainerWithData;
